module.exports = __webpack_public_path__ + "static/productos@2x-9cdc33940f2e3f2541906f06fc3d7419.png";